export const ADMISSION_TEST_LABELS = {
  ielts: 'IELTS',
  toefl: 'TOEFL',
  sat: 'SAT',
  gre_gmat: 'GRE/GMAT'
};

export const DEFAULT_ADMISSION_TESTS = {
  ielts: { attempted: '', score: '', date: '' },
  toefl: { attempted: '', score: '', date: '' },
  sat: { attempted: '', score: '', date: '' },
  gre_gmat: { attempted: '', score: '', date: '' }
};

export const emptyAdmissionTests = () =>
  JSON.parse(JSON.stringify(DEFAULT_ADMISSION_TESTS));

export const SCORE_PLACEHOLDERS = {
  ielts: 'e.g. 6.5',
  toefl: 'e.g. 90',
  sat: 'e.g. 1200',
  gre_gmat: 'e.g. 310'
};

export const parseAdmissionTests = (value) => {
  const defaults = emptyAdmissionTests();
  if (!value) return defaults;
  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value;
    if (!parsed || typeof parsed !== 'object') return defaults;
    return {
      ielts: { ...defaults.ielts, ...parsed.ielts },
      toefl: { ...defaults.toefl, ...parsed.toefl },
      sat: { ...defaults.sat, ...parsed.sat },
      gre_gmat: { ...defaults.gre_gmat, ...parsed.gre_gmat }
    };
  } catch {
    return defaults;
  }
};

export const serializeAdmissionTests = (admissionTests) => {
  if (!admissionTests || typeof admissionTests !== 'object') return null;
  return admissionTests;
};

export const hasAnyAdmissionTestData = (admissionTests) => {
  if (!admissionTests) return false;
  return Object.values(admissionTests).some(
    (row) => row && (row.attempted || row.score || row.date)
  );
};
